// extracted by mini-css-extract-plugin
module.exports = {"photo-wrapper":"_2BvpZ","story-wrapper":"_1PS1m"};